import React from 'react';

export default class PokazTraseMapComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            center:
                (Boolean(this.props.trasa[0])) ? this.props.trasa[0].latlng : {lat: 50.04, lng: 22},
            zoom: 10,
            mapTypeId: 'roadmap',
            lat: null,
            lng: null
        };
        this.getMap = this.getMap.bind(this)
    }

    componentDidMount() {
        let map = this.getMap();
        if (Boolean(this.props.trasa)) {

            if (this.props.pokazMarkery) {
                this.zaznaczMiejscowosciNaMapie(this.props.trasa, map)
            }

            this.rysujUproszczonaTrase(this.props.trasa, map)
        }
    }

    componentWillReceiveProps(nextprops) {
        if (Boolean(nextprops.trasa)) {
            let mapa = this.getMap(nextprops.trasa[0].latlng)
            if (nextprops.pokazMarkery) {
                this.zaznaczMiejscowosciNaMapie(nextprops.trasa, mapa)
            }
            this.rysujUproszczonaTrase(nextprops.trasa, mapa)
        }
    }

    getMap(center = this.state.center) {

        let map = new window.google.maps.Map(document.getElementById('map'), {
            center: center,
            zoom: this.state.zoom,
            mapTypeId: this.state.mapTypeId,
        });

        map.addListener('zoom_changed', () => {
            this.setState({
                zoom: map.getZoom()
            });
        });

        map.addListener('maptypeid_changed', () => {
            this.setState({
                mapTypeId: map.getMapTypeId(),
            });
        });

        return map
    }

    setMarker(wspolrzedne, mapa = this.getMap()) {
        if (Boolean(wspolrzedne)) {
            let marker = new window.google.maps.Marker({
                map: mapa,
                position: wspolrzedne
            })
        }
    }

    setCenter(wspolrzedne) {
        this.setState({center: wspolrzedne})
        this.getMap(wspolrzedne).setCenter(wspolrzedne)
        this.setMarker(wspolrzedne)
    }

    zaznaczMiejscowosciNaMapie(trasa, mapa) {
        let bounds = new window.google.maps.LatLngBounds();
        for (let i = 0; i < trasa.length; i++) {
            this.setMarker(trasa[i].latlng, mapa)
            bounds.extend(trasa[i].latlng)
        }
        mapa.fitBounds(bounds);
    }

    rysujUproszczonaTrase(trasa, mapa) {
        let bounds = new window.google.maps.LatLngBounds();
        let arr = Array.from(trasa, item => {
            return item.latlng
        })
        for (let i = 0; i < trasa.length; i++) {
            bounds.extend(trasa[i].latlng)
        }
        let trasaPath = new window.google.maps.Polyline({
            path: arr,
            geodesic: true,
            strokeColor: '#FF0000',
            strokeOpacity: 1.0,
            strokeWeight: 2
        });

        trasaPath.setMap(mapa);
        mapa.fitBounds(bounds);
    }

    render() {
        return (
            <div>
                <div style={{clear: 'both'}}>
                    <div id='map' style={{height: '60vh'}}/>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/konfiguracja/trasyConfig/trasy/googleMapComponents/PokazTraseMapComponent.js